import { render, staticRenderFns } from "./addItemDialog.vue?vue&type=template&id=4e0dd612&"
import script from "./addItemDialog.vue?vue&type=script&lang=js&"
export * from "./addItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./addItemDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports